<template>
    <div class="container" v-if="Address">
        <b-card bg-variant="light">
            <b-form-group horizontal
                            breakpoint="lg"
                            :label="MainLabel"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                            class="mb-0">
                <b-form-group horizontal
                            label="Full Name:"
                            label-class="text-sm-right"
                            label-for="billingFullName">
                <b-form-input id="billingFullName" v-model="Address.AttentionTo"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Line 1:"
                            label-class="text-sm-right"
                            label-for="nestedStreet">
                <b-form-input id="nestedStreet" v-model="Address.Line1"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Line 2:"
                            label-class="text-sm-right"
                            label-for="nestedStreet">
                <b-form-input id="nestedStreet" v-model="Address.Line2"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Line 3:"
                            label-class="text-sm-right"
                            label-for="nestedStreet">
                <b-form-input id="nestedStreet" v-model="Address.Line3"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="City:"
                            label-class="text-sm-right"
                            label-for="nestedCity">
                <b-form-input id="nestedCity" v-model="Address.City"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="State:"
                            label-class="text-sm-right"
                            label-for="nestedState">
                <b-form-input id="nestedState" v-model="Address.State"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Postcode:"
                            label-class="text-sm-right"
                            label-for="nestedPostcode" >
                    <b-form-input id="nestedPostcode" v-model="Address.Postcode"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Country:"
                            label-class="text-sm-right"
                            label-for="nestedCountry" >
                    <b-form-input id="nestedCountry" v-model="Address.Country"></b-form-input>
                </b-form-group>
                <!-- <b-form-group horizontal
                            label="Default Billing:"
                            label-class="text-sm-right"
                            label-for="defaultBilling" >
                    <b-form-checkbox v-model="Address.IsPrimaryBilling"></b-form-checkbox>
                </b-form-group> -->
                <!-- <b-form-group horizontal
                            label="Default Shipping:"
                            label-class="text-sm-right"
                            label-for="defeaultShipping" >
                    <b-form-checkbox v-model="Address.IsPrimaryShipping"></b-form-checkbox>
                </b-form-group> -->
                
            </b-form-group>
            <b-btn variant="success" class="float-right" @click="SaveAddress">Save</b-btn>
        </b-card>
    </div>
</template>

<script>
import store from "@/store.js";
import ProfileService from "../services/ProfileService";

function GetAddressInfo(key, done) {
  ProfileService.GetAddress(key)
    .then(response => {
      if (response.data) {
        done(null, response.data);
      } else {
        done("unable to get address");
      }
    })
    .catch(() => {
      done("unable to get address");
    });
}

export default {
  name: "EditAddress",
  data() {
    return {
        Address: null
    };
  },
  computed: {
      MainLabel() {
          if(this.Address.Oid) {
            return "Edit Address";
          } else {
            return "New Address";
          }
      }
  },
  beforeRouteEnter(to, from, next) {
      if(to.params.key) {
        GetAddressInfo(to.params.key, (err, address) => {
            next(vm => vm.setData(err, address));
        });
      }
      else
      {
        next(vm => {
                vm.setData(null, {
                    AttentionTo: "",
                    Line1: "",
                    Line2: "",
                    Line3: "",
                    City: "",
                    State: "",
                    Postcode: "",
                    Country: ""
                }); 
          }
        );
      }
    
  },
  beforeRouteUpdate(to, from, next) {
    this.Address = null;
    if(to.params.key) {
    GetAddressInfo(to.params.key, (err, address) => {
        this.setData(err, address);
        next();
        });
    }
    else
    {
        vm.setData(null, {
            AttentionTo: "",
            Line1: "",
            Line2: "",
            Line3: "",
            City: "",
            State: "",
            Postcode: "",
            Country: ""
        });
    }
  },
  methods: {
    setData(err, address) {
      if (err) {
        this.error = err.toString();
      } else {
        this.Address = address;
      }
    },
    SaveAddress() {
        ProfileService.SaveAddress(this.Address)
            .then((response => {
                if(response.data.Result.IsPrimaryBilling) {
                    this.$store.commit('UpdateCartBillingAddress', response.data.Result);
                }
                if(response.data.Result.IsPrimaryShipping) {
                    this.$store.commit('UpdateCartShippingAddress', response.data.Result);
                }
                this.$toasted.success('Address saved').goAway(3000);
                this.$router.go(-1);
            }))
            .catch((error) => {
                this.$toasted.error('Error Saving Address. Refresh and try again.').goAway(3000);
            });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/editaddress.vue